import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `ControlSemen/eliminarControlSemenSeleccion`, method: 'POST', body: {list}, token: token})
}